import UibookCase from 'uibook/case'
import React from 'react'
import TelegramButton from '../TelegramButton'

const I18N = {
  ru: {
    disabled: 'Отключено',
    loading: 'Загрузка',
    withBefore: 'С иконкой до текста',
    withAfter: 'С бейджем после текста',
    dangerLike: 'Контрастная кнопка',
    hintDisabled: 'Состояние disabled блокирует действие.',
    hintLoading: 'Loading показывает прогресс без прыжков layout.',
    hintBefore: 'Элемент before подходит для иконок.',
    hintAfter: 'Элемент after подходит для счетчиков.',
    hintDanger: 'White режим полезен на темной поверхности.',
  },
  en: {
    disabled: 'Disabled state',
    loading: 'Loading state',
    withBefore: 'With leading icon',
    withAfter: 'With trailing badge',
    dangerLike: 'Contrast button',
    hintDisabled: 'Disabled mode blocks interactions.',
    hintLoading: 'Loading keeps button size stable.',
    hintBefore: 'before slot is useful for icons.',
    hintAfter: 'after slot is useful for counters.',
    hintDanger: 'White mode gives high contrast on dark theme.',
  }
}

const PROPS = {
  onClick: UibookCase.event('onTelegramStateClick')
}

export default {
  background: 'dark',
  component: TelegramButton,
  i18n: true,
  cases: [
    locale => <UibookCase props={{ ...PROPS, mode: 'filled', disabled: true, description: I18N.en.hintDisabled }}>
      { I18N[locale].disabled }
    </UibookCase>,
    locale => <UibookCase props={{ ...PROPS, mode: 'bezeled', loading: true, description: I18N.en.hintLoading }}>
      { I18N[locale].loading }
    </UibookCase>,
    locale => <UibookCase props={{
      ...PROPS,
      mode: 'plain',
      before: <span aria-hidden='true'>#</span>,
      description: I18N.en.hintBefore
    }}>
      { I18N[locale].withBefore }
    </UibookCase>,
    locale => <UibookCase props={{
      ...PROPS,
      mode: 'gray',
      after: <span aria-hidden='true'>5</span>,
      description: I18N.en.hintAfter
    }}>
      { I18N[locale].withAfter }
    </UibookCase>,
    locale => <UibookCase props={{
      ...PROPS,
      mode: 'white',
      size: 'l',
      description: I18N.en.hintDanger
    }}>
      { I18N[locale].dangerLike }
    </UibookCase>
  ]
}
